import React, { useEffect, useState, Dispatch } from "react";
import ReactPlayer from "react-player"
import { Button, Grid, IconButton, Menu, TextField, Typography, Tooltip } from "@mui/material";

import { StyledContainer } from "../StyledComponents";
import AppBar from "../components/AppBar";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import NeuroGymGuide from "../documents/NeuroGymGuide.pdf"
import { useSelector } from "react-redux";
import { AppState } from "../reducers";
import { RoleType } from "../types/UserRole";
import { getEmbededURL, setEmbededURL } from "../api";
import { useTranslation } from "react-i18next";
import PreviewIcon from '@mui/icons-material/Preview';
import DownloadIcon from '@mui/icons-material/Download';

export default function Tutorial(props: { setTitle: Dispatch<React.SetStateAction<string>>}) {

    // for button and menu
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    // for embeded youtube video
    const [youtubeURL, setYouTubeURL] = useState<string>("");
    const [newYoutubeURL, setNewYoutubeURL] = useState<string>("");
    const userRole = useSelector<AppState, RoleType | null>(state => state.userRole);

    const {t} = useTranslation();
    useEffect(() => {
        getURL();
        props.setTitle("tutorials");
    }, [])

    const getURL = async () => {
        let url = await getEmbededURL();
        if (url) {
            setYouTubeURL(url)
        } else {
            setURL("https://youtu.be/tUaNM-TxZhQ");
        }
    }

    const setURL = async (url: string) => {
        await setEmbededURL(url);
        setYouTubeURL(url);
    }

    const handleMenuOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleURLSave = () => {
        setURL(newYoutubeURL);
        setNewYoutubeURL("");
    }

    return (
        <StyledContainer style={{ paddingTop: 90, paddingBottom: 80 }}>
            <Grid item xs={12}>
                <div style={{ display: "inline-flex" }}>
                {
                    userRole === "admin" && 
                    <>
                        <Button
                            id="update-button"
                            onClick={handleMenuOpen}
                            color="primary"
                            variant="contained"
                            aria-controls={open? "update-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open? "true" : undefined}
                            sx={{ marginInline: 1}}
                        >
                            {t("tutorials.updateURL")}
                        </Button>
                        
                        <Menu
                            id="update-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                "aria-labelledby": "update-button",
                            }}
                        >
                            <TextField
                                label="New Youtube URL"
                                variant="standard"
                                value={newYoutubeURL}
                                onChange={(e) => setNewYoutubeURL(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <Button
                                            onClick={handleURLSave}
                                            color="primary"
                                            variant="contained"
                                        >
                                            {t("butt.save")}
                                        </Button>
                                    )
                                }}
                                sx={{ width: "auto", marginInline: 1 }}
                            />
                        </Menu>
                    </>
                }
            </div>
            </Grid>
            <br />
            <Grid item xs={12} sm={6}>
                <Typography variant="h5" component="h4">
                    NeuroGym 腦有記 {t("tutorials.platformTutorial")} &nbsp;
                    <Tooltip title={t("tutorials.preview")}>
                        <IconButton>
                            <PreviewIcon sx={{ color: "FF0000"}} onClick={() => window.open(NeuroGymGuide, "_blank")} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("tutorials.download")}>
                        <IconButton href={NeuroGymGuide} download="NeuroGymGuide.pdf">
                            <DownloadIcon sx={{ color: "FF0000"}} />
                        </IconButton>
                    </Tooltip>
                    
                </Typography>
                {/* <div 
                    className="viewer"
                    style={{
                        border: '1px solid rgba(0, 0, 0, 0.3)',
                        height: '720px',
                        width: "100%"
                    }}
                >
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js" >
                        <Viewer fileUrl={NeuroGymGuide} />
                    </Worker>
                </div> */}
            </Grid>
            <br />
            <Grid item xs={12} sm={6}>
                <Typography variant="h5" component="h4">
                    NeuroGym 腦有記 {t("tutorials.introVideo")}
                </Typography>
                {/* <ReactPlayer url="https://youtu.be/tUaNM-TxZhQ"/> */}
                <ReactPlayer 
                    url={youtubeURL}
                    width='100%'
                    height='390px'
                />
            </Grid>
        </StyledContainer>
    )
}